/*
 * Copyright (c) 2019 Pegasystems Inc.
 * All rights reserved.
 */
import showData from '../../../data/show-data';
import {
  createDataObject,
  getDataObjectView,
  updateDataObject,
  openDataObjectFlowAction,
  submitDataObjectFlowAction
} from '../../../data';
import deleteDataObject from '../../../data/delete-data-object';
import getDataObjectActions from '../../../data/data-object-actions';

const dataEpics = [
  showData,
  createDataObject,
  getDataObjectView,
  updateDataObject,
  deleteDataObject,
  getDataObjectActions,
  openDataObjectFlowAction,
  submitDataObjectFlowAction
];
export default dataEpics;
